var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ className: "warning_svg__icon", viewBox: "0 0 1024 1024", xmlns: "http://www.w3.org/2000/svg", width: 200, height: 200 }, props), /* @__PURE__ */ React.createElement("path", { d: "M25.6 512a486.4 486.4 0 1 0 972.8 0 486.4 486.4 0 1 0-972.8 0Z", fill: "#FFCB0D" }), /* @__PURE__ */ React.createElement("path", { d: "M460.8 204.8h102.4v409.6H460.8zm0 512h102.4v102.4H460.8z", fill: "#2c2c2c" }));
export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PHBhdGggZD0iTTI1LjYgNTEyYTQ4Ni40IDQ4Ni40IDAgMSAwIDk3Mi44IDAgNDg2LjQgNDg2LjQgMCAxIDAtOTcyLjggMFoiIGZpbGw9IiNGRkNCMEQiLz48cGF0aCBkPSJNNDYwLjggMjA0LjhoMTAyLjR2NDA5LjZINDYwLjh6bTAgNTEyaDEwMi40djEwMi40SDQ2MC44eiIgZmlsbD0iIzJjMmMyYyIvPjwvc3ZnPg==";
